import { TypedDocumentNode, gql } from '@apollo/client';

import { useBrandedPlayButtonStatus_footballRivalsCurrentManager } from './__generated__/useBrandedButtonStatus.graphql';
import { BrandedPlayButtonStatus } from './types';

export const useBrandedPlayButtonStatus = (
  currentManager?: useBrandedPlayButtonStatus_footballRivalsCurrentManager | null,
  hasLineup?: boolean
) => {
  if (!currentManager) {
    return BrandedPlayButtonStatus.TICKET;
  }

  if (hasLineup) {
    return BrandedPlayButtonStatus.EDIT;
  }

  const { remainingArenaRequests, nextArenaFreePlayAvailableAt } =
    currentManager || {};

  const ticketStatus =
    remainingArenaRequests > 0
      ? BrandedPlayButtonStatus.TICKET
      : BrandedPlayButtonStatus.NO_TICKET;
  const buttonStatus = !nextArenaFreePlayAvailableAt
    ? BrandedPlayButtonStatus.FREE_PLAY
    : ticketStatus;

  return buttonStatus;
};

useBrandedPlayButtonStatus.fragments = {
  footballRivalsCurrentManager: gql`
    fragment useBrandedPlayButtonStatus_footballRivalsCurrentManager on FootballRivalsCurrentManager {
      id
      remainingArenaRequests
      nextArenaFreePlayAvailableAt
    }
  ` as TypedDocumentNode<useBrandedPlayButtonStatus_footballRivalsCurrentManager>,
};
